import "./editorialForms.css";

const categories = [
  "Meio Ambiente",
  "Direitos Humanos",
  "Animais",
  "Saúde",
  "Educação",
  "Política",
  "Trabalhista",
  "Consumidor",
  "Mobilidade",
  "Segurança",
  "Outro",
];

export default function PetitionForm({ data, onChange }) {
  const progress = data?.goalSignatures
    ? Math.min(100, ((data?.currentSignatures || 0) / data.goalSignatures) * 100)
    : 0;

  return (
    <div className="editorial_form petition_form">
      <div className="editorial_form_section">
        <label>
          Título da Petição <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Pela preservação do Parque Municipal"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Descrição <span className="required">*</span>
        </label>
        <textarea
          placeholder="Explique em detalhes o motivo da petição, o problema que quer resolver e a mudança que deseja ver..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={5000}
          rows={6}
        />
        <span className="editorial_form_counter">
          {(data?.description || "").length}/5000
        </span>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>
            Destinatário <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Ex: Prefeitura de São Paulo, Congresso Nacional..."
            value={data?.targetEntity || ""}
            onChange={(e) => onChange({ ...data, targetEntity: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Meta de Assinaturas <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="1000"
            value={data?.goalSignatures || ""}
            onChange={(e) =>
              onChange({
                ...data,
                goalSignatures: parseInt(e.target.value) || 0,
              })
            }
            min="1"
          />
        </div>

        <div className="editorial_form_section">
          <label>Assinaturas Atuais</label>
          <input
            type="number"
            placeholder="0"
            value={data?.currentSignatures || ""}
            onChange={(e) =>
              onChange({
                ...data,
                currentSignatures: parseInt(e.target.value) || 0,
              })
            }
            min="0"
          />
        </div>
      </div>

      {data?.goalSignatures > 0 && (
        <div className="editorial_form_section">
          <div
            style={{
              background: "var(--bg-third)",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: "var(--blue-color)",
                height: "12px",
                width: `${progress}%`,
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
              fontSize: "12px",
              color: "var(--color-secondary)",
            }}
          >
            <span>{(data?.currentSignatures || 0).toLocaleString("pt-BR")} assinaturas</span>
            <span>{progress.toFixed(0)}%</span>
            <span>Meta: {(data?.goalSignatures || 0).toLocaleString("pt-BR")}</span>
          </div>
        </div>
      )}

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Data de Início</label>
          <input
            type="date"
            value={data?.startDate?.split("T")[0] || ""}
            onChange={(e) =>
              onChange({
                ...data,
                startDate: new Date(e.target.value).toISOString(),
              })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Data de Encerramento</label>
          <input
            type="date"
            value={data?.endDate?.split("T")[0] || ""}
            onChange={(e) =>
              onChange({
                ...data,
                endDate: new Date(e.target.value).toISOString(),
              })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isVictory"
            checked={data?.isVictory || false}
            onChange={(e) => onChange({ ...data, isVictory: e.target.checked })}
          />
          <label htmlFor="isVictory">Vitória! Petição alcançou seu objetivo</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" />
        </svg>
        <span>
          Compartilhe sua petição para alcançar mais pessoas e conseguir mais assinaturas!
        </span>
      </div>
    </div>
  );
}
